// Нижняя граница десктопной раскладки. В CSS ей соответствуют
// @media (min-width: 1024px) и парный @media (max-width: 1023.98px) —
// НЕ 1023px: ширина вьюпорта бывает дробной (масштабирование дисплея, зум
// браузера), и пара 1023/1024 оставила бы диапазон 1023.01-1023.99 без
// единого сработавшего запроса
export const DESKTOP_MIN_WIDTH = 1024;

// Медиазапрос оверлея «поверните устройство» (OrientationLockOverlay.css).
// ВАЖНО: строка обязана совпадать с запросом в том CSS.
// Напрямую по ней о показе оверлея судить НЕЛЬЗЯ: (orientation: landscape)
// сравнивает ширину окна с высотой и срабатывает на вертикальном телефоне с
// открытой клавиатурой. Показан ли оверлей — отвечает
// checkIfOrientationLockActive (запрос плюс системная ориентация и проверка,
// что это телефон).
// Граница по ширине — та же, что у десктопной раскладки (DESKTOP_MIN_WIDTH):
// оверлей закрывает только мобильную раскладку, положенную на бок. Телефон
// от планшета она НЕ отличает и не должна: телефоны в горизонтали бывают
// шире планшетов (см. checkIfPhoneScreen)
export const ORIENTATION_LOCK_MEDIA_QUERY =
  '(orientation: landscape) and (hover: none) and (pointer: coarse) and (max-width: 1023.98px)';

// Порог изменения размера окна, ниже которого поле НЕ перерисовывается
// (мелкие сдвиги высоты на мобильных: системная панель кнопок Android,
// сворачивание адресной строки). Считается от размеров ПОСЛЕДНЕЙ РЕАЛЬНОЙ
// отрисовки, а не от предыдущего resize: иначе серия мелких изменений
// накопительно увела бы поле в любой размер, ни разу не пройдя порог.
// Канва растянута CSS на 100% контейнера (#phaser-container canvas в
// App.css) поверх Phaser.Scale.FIT, поэтому отклонение от базового размера
// дает не леттербоксинг, а растяжение — этот порог равен максимальному
// искажению пропорций гексов, которое игрок может увидеть.
// Исключение — экранная клавиатура: пока фокус в поле ввода, поле не
// пересобирается при любом сжатии окна по высоте (см.
// checkIfViewportShrunkByKeyboard в GameContent)
export const FIELD_REDRAW_SIZE_THRESHOLD = 0.1;

// Высота игровой шапки БЕЗ верхней безопасной зоны (та прибавляется сверху,
// см. .app-header в Header.css) на десктопе; уже 1024 px — 48. Дублируется в
// CSS числом var(--app-header-height) (App.css); при изменении править оба
// места
export const GAME_HEADER_HEIGHT = 56;

// Класс на <html>, запирающий скролл документа. Вешается только на время
// партии (см. GameContent): экран партии собран из fixed-панелей, а скролл
// страницы под ними сбивает попадание по клеткам поля. Стиль — в App.css
export const DOCUMENT_SCROLL_LOCK_CLASS = 'document-scroll-locked';

export const TOKEN_SCALE = 0.23;

export const UNIT_SCALE_MULTIPLIER = 0.8;
export const FACTION_UNIT_SCALE_MULTIPLIER = 0.85;
// Нейтральные отряды рисуются без контура (см. HexGridRenderer.renderUnit) и
// из-за этого выглядят мельче остальных — компенсируем размером иконки
export const NEUTRAL_UNIT_ICON_SCALE_MULTIPLIER = 1.2;
// Тень нейтрального отряда чуть меньше самой иконки: иконка увеличена, а тень
// вслед за ней разрослась бы за пределы гекса
export const NEUTRAL_UNIT_SHADOW_SCALE_MULTIPLIER = 0.9;
// Мигание боевых иконок (ближний бой и выстрел) по прозрачности. Сейчас
// ВЫКЛЮЧЕНО: иконка висит ровно, а «пульс» отряду дает волна по его ячейке
// (см. HexGridRenderer.buildCombatCellPulse). Вернуть мигание — поставить true
export const COMBAT_INDICATOR_FADING_ENABLED = false;

export const MARKER_FADING_DURATION_MS = 600;
export const MARKER_FADING_HOLD_MS = 600;
// Контур мигающего отряда (обреченного в бою или пережившего ловушку Гоблинов)
// гаснет вместе с его иконкой, но не до конца, а до этой прозрачности: по нему
// видно, где стоит отряд, пока иконка погашена
// (см. HexGridRenderer.addUnitFadingTween)
export const UNIT_FADING_OUTLINE_MIN_ALPHA = 0.5;
export const SUPPLY_ANIMATION_DURATION_MS = 400;
export const SUPPLY_ANIMATION_HOLD_MS = 1000;


export const STAT_ICON_SCALE = 0.025;
export const GOBLINS_TRAP_DAMAGE_ICON_SCALE = 0.03;

export const REROLL_ANIMATION_DURATION_MS = 800;
export const REROLL_ANIMATION_DELAY_MS = 150;

export const STAT_BACKGROUND_MODES = {
  NONE: 'none',

  LEFT: 'left',
  LEFT_SHORT: 'left_short',

  RIGHT: 'right',
  RIGHT_SHORT: 'right_short',
  RIGHT_LONG: 'right_long',

  // both: left side is always short, right could be short, standard or long
  BOTH: 'BOTH',
  BOTH_SHORT: 'BOTH_SHORT',
  BOTH_LONG: 'BOTH_LONG',
}

